import CloseIcon from '@mui/icons-material/Close'
import { Alert, Box, Button, Collapse, IconButton, Typography } from '@mui/material'
import { WebpushContext } from '~/contexts/WebpushContext'
import { FC, useContext, useEffect, useState } from 'react'
import { DateTime } from 'luxon'

const WEB_PUSH_ALERT_LOCAL_STORAGE_KEY = 'WEB_PUSH_ALERT_DISPLAY'

export const WebPushAlert: FC = () => {
  // 最後にアラートを非表示にしたのが1週間以上まえであれば、再度表示する
  const [isDisplay, setIsDisplay] = useState(() => {
    const lastDate = localStorage.getItem(WEB_PUSH_ALERT_LOCAL_STORAGE_KEY)
    return lastDate ? DateTime.fromISO(lastDate).plus({ week: 1 }) < DateTime.now() : true
  })

  const handleClose = () => {
    setIsDisplay(false)
    localStorage.setItem(WEB_PUSH_ALERT_LOCAL_STORAGE_KEY, DateTime.now().toISO())
  }

  const { permission, setPermission } = useContext(WebpushContext)

  const [supported, setSupported] = useState(false)

  const handleRequest = async () => {
    if (!supported) return
    const newPermission = await Notification.requestPermission()
    setPermission(newPermission)
  }

  useEffect(() => {
    if ('Notification' in window) {
      setSupported(true)
    }
  }, [])

  if (!supported) return null

  return (
    <Box>
      <Collapse in={isDisplay && permission === 'default'}>
        <Alert
          severity="info"
          action={
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Button variant="contained" onClick={handleRequest} size="small">
                通知ON
              </Button>
              <IconButton size="small" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
          }
        >
          <Typography variant="body2">
            通知を有効にすることで、インフルエンサーからの返信に気付きやすくなります！
          </Typography>
        </Alert>
      </Collapse>
    </Box>
  )
}
